export default "__VITE_ASSET__CpeAeeyi__"